<div id="tooltip" class="custom-tooltip flex justify-end" role="tooltip">
  Enabled when 'Send for approval'<br />
  request is approved
</div>
